import { FilesystemDirectory, Plugins, Capacitor } from "@capacitor/core";
import { writeFile } from "capacitor-blob-writer";

const { FFMpeg, Filesystem } = Plugins;

export const gridTypes = [
  [
    [0, 1],
    [2, 3],
  ],
  [[0, 1]],
  [[0], [1]],
];

const predefinedVideoFilter = {
  0: "[0delayedvideo][1]hstack[top];[2][3]hstack[bottom];[top][bottom]vstack[v]",
  1: "[0delayedvideo][1]hstack[v]",
  2: "[0delayedvideo][1]vstack[v]",
};

/**
 *
 * @param {Object} options
 * @param {Blob[]} options.videos
 * @param {number} options.latency
 * @param {boolean} options.audioOnly
 */
export async function render(options) {
  await Plugins.Filesystem.requestPermissions();
  const { videos, latency, audioOnly, gridType } = options;

  const args = [];
  for (const [i, video] of videos.entries()) {
    console.log(video, i);
    const { uri } = await writeFile({
      path: `${i}.webm`,
      directory: FilesystemDirectory.Cache,
      data: video,
    });
    args.push("-i", uri);
  }
  
  let { uri } = await writeFile({
    path: `watermark.png`,
    directory: FilesystemDirectory.Cache,
    data: await fetch("https://localhost/assets/images/watermark.png").then(r => r.blob()),
  });
  args.push("-i", uri);

  let filters = [
    `[0]adelay=${latency}ms[0delayedaudio]`,
    `${videos
      .map((_, i) => (i == 0 ? "[0delayedaudio]" : `[${i}]`))
      .join("")}amix=inputs=${videos.length}[a]`,
  ];

  if (!audioOnly) {
    filters.push(
      `[0]tpad=start_mode=clone:start_duration=${latency}ms[0delayedvideo]`
    );
    filters.push(predefinedVideoFilter[gridType]);
  }

  if (!audioOnly) {
    filters.push(`[v][${videos.length}]overlay=W-w-10:H-h-10[v]`);
  }
  args.push("-filter_complex", `"${filters.join(";")}"`);

  args.push("-map", "[a]");
  args.push("-preset", "medium");

  let output = "output.mp3";

  if (!audioOnly) {
    args.push("-map", "[v]");
    args.push("-crf", "1");
    args.push("-vc", "libx264");
    args.push("-r", "60");
    args.push("-vb", "20M");
    output = "output.mp4";
  }

  const result = await Filesystem.getUri({
    directory: FilesystemDirectory.ExternalStorage,
    path: output,
  });

  args.push(result.uri);
  args.push("-y");
  args.push("-threads 34");

  await FFMpeg.run({ args: args.join(" ") });

  return fetch(Capacitor.convertFileSrc(result.uri)).then((r) => r.blob());
}

